module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_fr-50b890f04cad7a20759575adcfa28d78.png";